import { Page } from '@app/components/page/Page';
import { AdminModule } from '@app/modules/admin/index';
import { BreadcrumbItem } from '@mi-front/ui';
import React from 'react';

import { FormattedMessage } from 'react-intl';
export const GroupsBreadcrumbs = (p: { activeText?: React.ReactNode; title?: React.ReactNode }) => {
  let items: BreadcrumbItem[];

  const groupsText = (
    <span className="text-capitalize-first">
      <FormattedMessage id="common.entities.groups" defaultMessage="grupos" />
    </span>
  );

  const activeText = p.title || p.activeText;

  if (activeText) {
    items = [
      {
        content: groupsText,
        href: '/admin/groups',
      },
      {
        content: activeText,
        active: true,
      },
    ];
  } else {
    items = [
      {
        content: groupsText,
        active: true,
      },
    ];
  }

  return <Page.ModuleBreadcrumbs module={AdminModule} items={items} />;
};
